import {LoginTypeCode} from '@/consts/loginTypes';
import RegisterLink from '@/containers/LoginPageV2/components/LoginForm/RegisterLink';
import {getLoginContent} from '@/services/content/appContent.typed';

import LoginMethodSwitch from './LoginMethodSwitch';

interface LoginFooterProps {
    currentMethod: LoginTypeCode;
    onSwitch?: () => void;
    canSwitchMethod: boolean;
}

const LoginFooter = ({currentMethod, onSwitch, canSwitchMethod}: LoginFooterProps) => {
    const {registerHereButton, newToIqosText} = getLoginContent();

    return (
        <div className='mt-6 flex flex-col gap-8 ml:mt-4 ml:gap-6'>
            {registerHereButton && <RegisterLink button={registerHereButton} prefixText={newToIqosText} />}
            {canSwitchMethod && <LoginMethodSwitch currentMethod={currentMethod} onSwitch={onSwitch} />}
        </div>
    );
};

export default LoginFooter;
